import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { ButtonType } from '@challenger6/vm-pattern-library/button/button.interface';
import { FloatingBannerContent } from '../../models/floating-banner-content.model';

@Component({
  selector: 'vm-floating-banner-section',
  templateUrl: './floating-banner-section.component.html',
  styleUrls: ['./floating-banner-section.component.scss'],
})
export class FloatingBannerSectionComponent implements OnInit {
  @Input() data: FloatingBannerContent;

  isDDBarInView = false;
  buttonType = ButtonType;

  constructor(private elementReference: ElementRef) {}

  @HostListener('window:scroll') onScroll(): void {
    const inView = this.isElementInView(this.elementReference.nativeElement);

    if (inView === this.isDDBarInView) {
      return;
    }
    if (inView) {
      (this.elementReference.nativeElement as HTMLElement).removeAttribute('style');
    } else {
      (this.elementReference.nativeElement as HTMLElement).setAttribute(
        'style',
        'min-height:' + this.elementReference.nativeElement.offsetHeight + 'px; display: block;'
      );
    }
    this.isDDBarInView = inView;
  }

  ngOnInit(): void {}


  isElementInView(myElement) {
    if (!myElement) {
      return false;
    }
    const rectangleBounding = myElement.getBoundingClientRect();
    const myElementHeight = myElement.offsetHeight;
    const myElementWidth = myElement.offsetWidth;
  
    if (
      rectangleBounding.top >= -myElementHeight &&
      rectangleBounding.left >= -myElementWidth &&
      rectangleBounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth &&
      rectangleBounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight
    ) {
      return true;
    } else {
      return false;
    }
  };
}
